import { useParams } from '@tanstack/react-router'
import { OccupyingParcelCmp } from '@/components/features/parcels/creation/OccupyingParcelCmp'
import { PageContainer } from '@/components/features/shared/PageContainer'

export const OccupyingParcelPage = () => {
  const { contractId, parcelId } = useParams({ strict: false }) as { contractId: string, parcelId: string }

  return (
    <PageContainer>
      <OccupyingParcelCmp contractId={contractId} parcelId={parcelId} />
    </PageContainer>
  )
}
